import ApiService from './ApiService';

export default class FlexparkService {
  static getUserFlexpark = async ({ id }) =>
    ApiService.get(`/user_flexparks/${id}`);
}
